import { useCookies } from 'react-cookie';

export function getLevel() {
  const cookieName = 'bhoCookies';
  const [cookies, setCookie] = useCookies([cookieName]);

  const acceptedLevels = (!!cookies[cookieName]) ? cookies[cookieName].split('|').length : null;
  return acceptedLevels;
}
